import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentRegistration: null,
  formData: {},
  isLoading: false,
  error: null,
  currentStep: 1,
  formProgress: 14.3,
  memberRequestsProgress: 0,
  isMemberRequestsLoading: false,
};

const memberRegistrationSlice = createSlice({
  name: "memberRegistration",
  initialState,
  reducers: {
    setCurrentRegistration: (state, action) => {
      state.currentRegistration = action.payload;
    },
    updateFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    clearFormData: (state) => {
      state.formData = {};
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
      state.formProgress = Math.min(100, action.payload * 14.3);
    },
    setMemberRequestsProgress: (state, action) => {
      const numericValue = Number(action.payload);
      state.memberRequestsProgress = Number.isFinite(numericValue)
        ? Math.max(0, Math.min(100, numericValue))
        : 0;
    },
    setMemberRequestsLoading: (state, action) => {
      state.isMemberRequestsLoading = Boolean(action.payload);
    },
    resetMemberRequestsProgress: (state) => {
      state.memberRequestsProgress = 0;
      state.isMemberRequestsLoading = false;
    },
    resetRegistrationState: (state) => {
      return initialState;
    },
  },
});

// Export actions
export const {
  setCurrentRegistration,
  updateFormData,
  clearFormData,
  setLoading,
  setError,
  setCurrentStep,
  setMemberRequestsProgress,
  setMemberRequestsLoading,
  resetMemberRequestsProgress,
  resetRegistrationState,
} = memberRegistrationSlice.actions;

// Export selectors
export const selectCurrentRegistration = (state) =>
  state.memberRegistration.currentRegistration;
export const selectFormData = (state) => state.memberRegistration.formData;
export const selectIsLoading = (state) => state.memberRegistration.isLoading;
export const selectError = (state) => state.memberRegistration.error;
export const selectCurrentStep = (state) =>
  state.memberRegistration.currentStep;
export const selectFormProgress = (state) =>
  state.memberRegistration.formProgress;
export const selectMemberRequestsProgress = (state) =>
  state.memberRegistration.memberRequestsProgress;
export const selectIsMemberRequestsLoading = (state) =>
  state.memberRegistration.isMemberRequestsLoading;

export default memberRegistrationSlice.reducer;
